import React from "react";

export default function IntendedUseForm({ data, onChange, onNext, onBack }) {
  const types = [
    "Vitamins (e.g., multivitamins or individual vitamins such as vitamin D and biotin)",
    "Minerals (e.g., calcium, magnesium, and iron)",
    "Herbs and other botanicals (e.g., echinacea and ginger)",
    "Botanical compounds (e.g., caffeine and curcumin)",
    "Amino acids (e.g., tryptophan and glutamine)",
    "Dietary substances (e.g., enzymes and live microbials such as probiotics)",
    "Concentrates, metabolites, constituents, extracts, or combinations",
  ];
  const handleToggleType = (type) => {
    const currentSelected = data.type || [];
    if (currentSelected.includes(type)) {
      onChange("type", currentSelected.filter((t) => t !== type));
    } else {
      onChange("type", [...currentSelected, type]);
    }
  };

  return (
    <div>
      <h4 className="text-success">Intended Use</h4>

      <div className="mb-3">
        <label htmlFor="intendedUse">Intended Use</label>
        <textarea
          id="intendedUse"
          className="form-control"
          value={data.intendedUse ?? ""}
          onChange={(e) => onChange("intendedUse", e.target.value)}
        />
      </div>

      <div className="row">
       <div className="mb-4">
        <label className="mb-2">Type</label>
        <div className="p-3 border rounded-3 bg-white shadow-sm">
          <div className="row g-2">
            {types.map((t, idx) => {
              const isSelected = (data.type || []).includes(t);
              return (
                <div className="col-md-6 col-lg-4" key={idx}>
                  <div 
                    onClick={() => handleToggleType(t)}
                    className={`d-flex align-items-center p-2 rounded-2 border transition-all cursor-pointer h-100 ${
                      isSelected ? 'bg-success bg-opacity-10 border-success shadow-xs' : 'bg-light border-transparent'
                    }`}
                  >
                    <div 
                      className="me-2 d-flex align-items-center justify-content-center rounded"
                      style={{ 
                        minWidth: '18px', height: '18px', 
                        border: `1.5px solid ${isSelected ? '#198754' : '#ced4da'}`,
                        backgroundColor: isSelected ? '#198754' : '#fff'
                      }}
                    >
                      {isSelected && <i className="bi bi-check text-white" style={{ fontSize: '12px' }}></i>}
                    </div>
                    <span className={`small ${isSelected ? 'fw-bold text-success' : 'text-muted'}`} style={{ fontSize: '0.75rem' }}>
                      {t}
                    </span>
                  </div>
                </div>
              );
            })}
          </div>
          <div className="mt-2 text-muted" style={{ fontSize: '0.65rem' }}>
            <i className="bi bi-info-circle me-1"></i> You can select multiple categories.
          </div>
        </div>
      </div>

        <div className="col-md-4 mb-3">
          <label htmlFor="function">Function</label>
          <input
            id="function"
            type="text"
            className="form-control"
            value={data.function ?? ""}
            onChange={(e) => onChange("function", e.target.value)}
          />
        </div>

        <div className="col-md-4 mb-3">
          <label htmlFor="functionalUse">Functional Use</label>
          <input
            id="functionalUse"
            type="text"
            className="form-control"
            value={data.functionalUse ?? ""}
            onChange={(e) => onChange("functionalUse", e.target.value)}
          />
        </div>
      </div>

      <div className="mb-3">
        <label htmlFor="recommendation">Recommendation</label>
        <textarea
          id="recommendation"
          className="form-control"
          value={data.recommendation ?? ""}
          onChange={(e) => onChange("recommendation", e.target.value)}
        />
      </div>

      <div className="mb-3">
        <label htmlFor="disclaimer">Disclaimer</label>
        <textarea
          id="disclaimer"
          className="form-control"
          value={data.disclaimer ?? ""}
          onChange={(e) => onChange("disclaimer", e.target.value)}
        />
      </div>

      <div className="d-flex justify-content-between">
        <button type="button" className="btn btn-secondary" onClick={onBack}>
          Back
        </button>
        <button type="button" className="btn btn-primary" onClick={onNext}>
          Next
        </button>
      </div>
    </div>
  );
}
